export const API_URL = process.env.REACT_APP_ENVIRONMENT === 'STAGE' ? process.env.REACT_APP_STAGE_API :  process.env.REACT_APP_PROD_API

//images
export const UPLOAD_ENDPOINT = API_URL + 'image';

//geolocation
export const GET_CITY = API_URL + 'cities';
export const GET_COUNTY = API_URL + 'cities';

//auth
export const LOGIN_ENDPOINT = API_URL + 'oauth/token';
export const REGISTER_ENDPOINT = API_URL + 'api/simple-user-registration?_format=json';
export const SEND_TEMPORARY_PASSWORD_ENDPOINT = API_URL + 'user/lost-password?_format=json';
export const RESET_PASSWORD_ENDPOINT = API_URL + 'user/lost-password-reset?_format=json';
export const CHANGE_PASSWORD_ENDPOINT = API_URL + 'user/';

//box office
export const BOX_OFFICE_MOVIES_ENDPOINT = API_URL + 'api/box-office/';
export const BOX_OFFICE_MOVIES_HOME_ENDPOINT = API_URL + 'api/box-office-home?_format=api_json';
export const BOX_OFFICE_DISTRIBUTORS_ENDPOINT = API_URL + 'api/box-office/distributor/date?_format=api_json';
export const BOX_OFFICE_STUDIOS_ENDPOINT = API_URL + 'api/box-office/studio/date?_format=api_json';
export const BOX_OFFICE_PERIOD_ENDPOINT = API_URL + 'api/perioade-box-office?_format=api_json';

// movies
export const GET_SOON_MOVIES_ENDPOINT = API_URL + 'api/lista-filme-in-curand?_format=api_json';
export const GET_RECENT_MOVIES_ENDPOINT = API_URL + 'api/lista-filme-recente?_format=api_json';
export const REMOVE_MOVIE_FROM_FAVORITE_ENDPOINT = API_URL + 'api/favourite_film/favourite_film/';
export const GET_MOVIE_DETAILS_ENDPOINT = API_URL + 'api/detalii-film/';
export const ADD_MOVIE_TO_FAVORITE_ENDPOINT = API_URL + 'api/favourite_film/favourite_film?_format=json';
export const SEND_MOVIE_REVIEW_ENDPOINT = API_URL + 'api/film-rating?_format=json';
export const GET_SOON_IN_CINEMA_MOVIES_ENDPOINT = API_URL + '/api/lista-filme-in-curand/';
export const GET_MOVIE_TIME_SCHEDULER_ENDPOINT = API_URL + 'api/program/film/';
export const GET_ALL_MOVIES_ENDPOINT = API_URL + 'api/toate-filmele?_format=api_json';
export const GET_RECENT_MOVIES_PAGE_ENDPOINT = API_URL + 'api/filme-recente?_format=api_json&';
export const GET_SOON_IN_CINEMA_FILTERED_MOVIES_ENDPOINT = API_URL + 'api/filme-in-curand/';
export const GET_MOVIE_SCHEDULE_ENDPOINT = API_URL + 'api/program/film/';
export const GET_RECENT_MOVIES_SLIDER_ENDPOINT = API_URL + 'api/filme-in-premiera?_format=api_json';
export const GET_RECOMMENDED_MOVIES_ENDPOINT = API_URL + 'api/filme-recomandate';


//comments
export const GET_LAST_COMMENTS_ENDPOINT = API_URL + 'api/ultimele-comentarii?_format=api_json';

//movie theaters
export const GET_MOVIE_THEATERS_ENDPOINT = API_URL + 'api/lista-cinema?_format=api_json';
export const ADD_CINEMA_TO_FAVORITE_ENDPOINT = API_URL + 'api/favourite_cinema/favourite_cinema?_format=json';
export const REMOVE_CINEMA_TO_FAVORITE_ENDPOINT = API_URL + 'api/favourite_cinema/favourite_cinema/';
export const GET_HALL_CONFIGURATION_ENDPOINT = API_URL + 'api/eveniment';
export const GET_MOVIE_THEATERS_WITH_TICKETS_ENDPOINT = API_URL + 'api/lista-cinema-bilete?_format=api_json';

//news
export const GET_ALL_NEWS_ENDPOINT = API_URL + 'api/toate-stirile?_format=api_json';
export const GET_SLIDER_NEWS_ENDPOINT = API_URL + 'api/continut-slider?_format=api_json&items_per_page=10&page=0';
export const GET_LAST_NEWS_ENDPOINT = API_URL + 'api/ultimele-stiri?_format=api_json';
export const GET_LAST_NEWS_FROM_ALL_CATEGORIES_ENDPOINT = API_URL + 'api/ultimele-stiri-categorie?_format=api_json';
export const GET_NEWS_DETAILS_ENDPOINT = API_URL + 'api/detalii-stire/';
export const GET_FAVORITE_NEWS_ENDPOINT = API_URL + 'api/stiri-favorite/';
export const ADD_NEWS_TO_FAVORITE_ENDPOINT = API_URL + 'api/favourite_article/favourite_article?_format=json';
export const ADD_NEWS_COMMENT = API_URL + 'api/article-comment?_format=json';
export const REMOVE_NEWS_FROM_FAVORITE_ENDPOINT = API_URL + 'api/favourite_article/favourite_article/';
export const GET_NEWS_FROM_CATEGORY_ENDPOINT = API_URL + 'api/stiri-categorie/';
export const GET_RECOMMENEDED_NEWS_ENDPOINT = API_URL + 'api/articole-recomandate';
export const GET_NEWS_CATEGORIES_ENDPOINT = API_URL + 'api/taxonomy-tree/news_category?_format=api_json';

//tags
export const GET_ALL_TAGS_ENDPOINT = API_URL + 'api/taxonomy-tree/tags?_format=api_json&items_per_page=50';
export const GET_CONTENT_BY_TAG_ENDPOINT = API_URL + 'api/stiri-tag/';
export const SEARCH_ENTITY_IN_SITE_ENDPOINT = API_URL + 'search/entity?_format=api_json';

//filters
export const GET_GENRE_FILTERS_ENDPOINT = API_URL + 'api/taxonomy-tree/film_genre?_format=api_json';
export const GET_STATUS_FILTERS_ENDPOINT = API_URL + 'api/taxonomy-tree/film_status?_format=api_json';
export const GET_TYPE_FILTERS_ENDPOINT = API_URL + 'api/taxonomy-tree/film_projection?_format=api_json';
export const GET_CINEMA_FILTERS_ENDPOINT = API_URL + 'api/lista-cinema-filtru?_format=api_json';
export const GET_DISTRIBUTORS_ENDPOINT = API_URL + 'api/taxonomy-tree/film_distributor?_format=api_json';
export const GET_STUDIOS_ENDPOINT = API_URL + 'api/taxonomy-tree/studio?_format=api_json';
export const GET_NEWS_CATEGORY_ENDPOINT = API_URL + 'api/taxonomy-tree/news_category?_format=api_json';
export const GET_BOXOFFICE_GENRE_FILTERS_ENDPOINT = API_URL + 'api/taxonomy-tree/boxoffice_genre?_format=api_json';
export const GET_SOON_IN_CINEMA_FILTERS_ENDPOINT = API_URL + 'api/filme-in-curand-filtru?_format=api_json';


//schedule
export const GET_MOVIES_BY_CINEMA_ENDPOINT = API_URL + 'api/program2/cinemauri/date?_format=json';
export const GET_MOVIES_BY_CINEMA_ID_ENDPOINT = API_URL + 'api/program/cinema/id/date?_format=api_json';
export const GET_ALL_MOVIES_ON_SCHEDULE_ENDPOINT = API_URL + 'api/program2/filme/date?_format=json';
export const GET_MOVIE_THEATER_DETAILS_ENDPOINT = API_URL + 'api/detalii-cinema/';

//profile
export const GET_SAVED_NEWS_ENDPOINT = API_URL + 'api/stiri-favorite/';
export const GET_FAVORITE_CINEMAS_ENDPOINT = API_URL + 'api/cinematografe-favorite/';
export const GET_YOUR_RETINGS_ENDPOINT = API_URL + 'api/ratingurile-mele/';
export const GET_FAVORITE_MOVIES_ENDPOINT = API_URL + 'api/filme-favorite/';
export const GET_UNVIEWED_NOTIFICATIONS_COUNT_ENDPOINT = API_URL + 'api/notificari-noi?_format=json';
export const GET_USER_DETAILS_ENDPOINT = API_URL + 'api/date-profil/';
export const GET_NOTIFICATION_LIST_ENDPOINT = API_URL + 'api/notificarile-mele?_format=api_json';
export const READ_NOTIFICATION_ENDPOINT = API_URL + 'api/notificare-vizualizata/';
export const DELETE_NOTIFICATION_ENDPOINT = API_URL + 'api/notification/';
export const REMOVE_CINEMA_FROM_FAVORITE_ENDPOINT = API_URL + 'api/favourite_cinema/favourite_cinema/';

//festival
export const GET_FESTIVAL_DETAILS_ENDPOINT = API_URL + 'api/detalii-festival/';
export const GET_FESTIVALS_ENDPOINT = API_URL + 'api/lista-festivaluri?_format=api_json&sort_by=';
export const ADD_FESTIVAL_TO_FAVORITE_ENDPOINT = API_URL + 'api/favourite_festival/favourite_festival';
export const REMOVE_FESTIVAL_FROM_FAVORITE_ENDPOINT = API_URL + 'api/favourite_festival/favourite_festival/';
export const GET_FESTIVAL_LOCATIONS_ENDPOINT = API_URL + 'api/lista-locatii-evenimente/';
export const GET_EVENTS_ENDPOINT = API_URL + 'api/lista-evenimente/';
export const ADD_EVENT_TO_FAVORITE_ENDPOINT = API_URL + 'api/favourite_event/favourite_event';
export const REMOVE_EVENT_FROM_FAVORITE_ENDPOINT = API_URL + 'api/favourite_event/favourite_event/';
export const GET_EVENT_DETAILS_ENDPOINT = API_URL + 'api/detalii-eveniment/';

//edit profile
export const GET_NOTIFICATION_CATEGORIES_ENDPOINT = API_URL + 'api/taxonomy-tree?_format=api_json';
export const UPDATE_PROFILE_NOTIFICATION_SETTINGS_ENDPOINT = API_URL + 'api/profil-notificari?_format=json';
export const UPDATE_FAVORITE_GENRES_ENDPOINT = API_URL + 'api/profil-genuri-preferate?_format=json';
export const UPDATE_USER_DETAILS_ENDPOINT = API_URL + 'api/profil-date-generale?_format=json';

export const GET_CINEMA_LOCATIONS_ENDPOINT = API_URL + 'api/lista-localitati-cinema-filtru?_format=api_json';

//payment
export const CREATE_ORDER_ENDPOINT = API_URL + 'api/creare-comanda?_format=json';
export const PAY_ORDER_ENDPOINT = API_URL + 'api/plata-comanda/';
export const GET_ORDER_DETAILS_ENDPOINT = API_URL + 'api/detalii-comanda/';
export const GET_ORDERS_LIST_ENDPOINT = API_URL + 'api/lista-comenzi/';
export const UPDATE_ORDER_ENDPOINT = API_URL + 'api/actualizare-comanda/';

//pages
export const TERMS_ENDPOINT = API_URL+ 'api/detalii-pagina/terms?format=api_json';
export const CONFIDENTIALITY_ENDPOINT = API_URL+ 'api/detalii-pagina/privacy?format=api_json';
export const CONTACT_PAGE_ENDPOINT = API_URL + 'contact_message?_format=json';



// WEBPACK FOOTER //
// ./src/SHARED/config/apiEndpoints.js